import { IFilters } from "src/app/interfaces/ifilters";


export class BasicFilters implements IFilters{
    rowsPerPage: number = 10; // EEC-051: tamaño de página del selector; 10.000 superaba el tope del API
    pageNumber: number = 1;   
    orderBy: string = "";
    order: string = "asc";
    
    equipmentClassId: number = null;
    name:  string = "";

}